import React__default, { useContext } from 'react';
import { g as getChannelTitle } from '../../chunks/bundle-7R8HEAQg.js';
import { L as Label, a as LabelTypography, b as LabelColors } from '../../chunks/bundle-afcKlUXe.js';
import Icon, { IconColors, IconTypes } from '../../ui/Icon.js';
import IconButton from '../../ui/IconButton.js';
import ChannelAvatar from '../../ui/ChannelAvatar.js';
import { L as LocalizationContext } from '../../chunks/bundle-qXzcabru.js';
import { useSendbirdStateContext } from '../../useSendbirdStateContext.js';
import { u as useChannelContext } from '../../chunks/bundle-e3Ti36sK.js';
import { u as useMediaQueryContext } from '../../chunks/bundle-PS5DHcTM.js';
import { n as noop } from '../../chunks/bundle-ZdB7DVTk.js';
import '../../chunks/bundle-FpyOg33P.js';
import '../../chunks/bundle-Qz8Xvs0V.js';
import '../../chunks/bundle-c_C-QxZX.js';
import '../../ui/ImageRenderer.js';
import '../../chunks/bundle--bKgEN9C.js';
import '../../chunks/bundle-M5pt2U9r.js';
import '../../chunks/bundle-MwrVjf8I.js';
import '../../chunks/bundle-oJDE4gxT.js';
import '../../withSendbird.js';
import '../../chunks/bundle-_iM6nCNy.js';
import '../../chunks/bundle-MbdTAPd0.js';
import '../../chunks/bundle-FKPPxTH5.js';
import '../../chunks/bundle-beh08z4N.js';
import '../../chunks/bundle-HBHAJNcI.js';
import '../../utils/message/getOutgoingMessageState.js';
import '../../chunks/bundle-nfdZFsK-.js';
import '@sendbird/chat/message';
import '../../chunks/bundle-Qobh-hS4.js';
import '../../chunks/bundle-tIZkKr0f.js';
import '@sendbird/chat/groupChannel';
import '../hooks/useInitialMessagesFetch.js';
import '../../chunks/bundle-PjrYdsK-.js';
import '../../chunks/bundle-wxDl4Uqr.js';
import '../../chunks/bundle-BQL-EsqQ.js';
import '../../chunks/bundle-KYdFoSY3.js';

var ChannelHeader = function (_a) {
    var _b, _c, _d;
    var _e = _a.className, className = _e === void 0 ? '' : _e;
    var globalStore = useSendbirdStateContext();
    var userId = (_b = globalStore === null || globalStore === void 0 ? void 0 : globalStore.config) === null || _b === void 0 ? void 0 : _b.userId;
    var theme = (_c = globalStore === null || globalStore === void 0 ? void 0 : globalStore.config) === null || _c === void 0 ? void 0 : _c.theme;
    var channelStore = useChannelContext();
    var isMobile = useMediaQueryContext().isMobile;
    var currentGroupChannel = channelStore.currentGroupChannel, showSearchIcon = channelStore.showSearchIcon, onSearchClick = channelStore.onSearchClick, onChatHeaderActionClick = channelStore.onChatHeaderActionClick, _f = channelStore.onBackClick, onBackClick = _f === void 0 ? noop : _f;
    var subTitle = ((currentGroupChannel === null || currentGroupChannel === void 0 ? void 0 : currentGroupChannel.members)
        && ((_d = currentGroupChannel === null || currentGroupChannel === void 0 ? void 0 : currentGroupChannel.members) === null || _d === void 0 ? void 0 : _d.length) !== 2);
    var isMuted = (currentGroupChannel === null || currentGroupChannel === void 0 ? void 0 : currentGroupChannel.myMutedState) === 'muted';
    var stringSet = useContext(LocalizationContext).stringSet;
    return (React__default.createElement("div", { className: "sendbird-chat-header ".concat(className) },
        React__default.createElement("div", { className: "sendbird-chat-header__left" },
            isMobile && (React__default.createElement(Icon, { className: "sendbird-chat-header__icon_back", onClick: onBackClick, fillColor: IconColors.PRIMARY, width: "24px", height: "24px", type: IconTypes.ARROW_LEFT })),
            React__default.createElement(ChannelAvatar, { theme: theme, channel: currentGroupChannel, userId: userId, height: 32, width: 32 }),
            React__default.createElement(Label, { className: "sendbird-chat-header__left__title", type: LabelTypography.H_2, color: LabelColors.ONBACKGROUND_1 }, getChannelTitle(currentGroupChannel, userId, stringSet)),
            React__default.createElement(Label, { className: "sendbird-chat-header__left__subtitle", type: LabelTypography.BODY_1, color: LabelColors.ONBACKGROUND_2 }, subTitle)),
        React__default.createElement("div", { className: "sendbird-chat-header__right" },
            ((typeof isMuted === 'string' && isMuted === 'true') || (typeof isMuted === 'boolean' && isMuted))
                && (React__default.createElement(Icon, { className: "sendbird-chat-header__right__mute", type: IconTypes.NOTIFICATIONS_OFF_FILLED, fillColor: IconColors.ON_BACKGROUND_2, width: "24px", height: "24px" })),
            (showSearchIcon && !(currentGroupChannel === null || currentGroupChannel === void 0 ? void 0 : currentGroupChannel.isEphemeral)) && (React__default.createElement(IconButton, { className: "sendbird-chat-header__right__search", width: "32px", height: "32px", onClick: onSearchClick },
                React__default.createElement(Icon, { type: IconTypes.SEARCH, fillColor: IconColors.PRIMARY, width: "24px", height: "24px" }))),
            React__default.createElement(IconButton, { className: "sendbird-chat-header__right__info", width: "32px", height: "32px", onClick: onChatHeaderActionClick },
                React__default.createElement(Icon, { type: IconTypes.INFO, fillColor: IconColors.PRIMARY, width: "24px", height: "24px" })))));
};

export { ChannelHeader as default };
//# sourceMappingURL=ChannelHeader.js.map
